import { render, staticRenderFns } from "./widgetPage.vue?vue&type=template&id=d6b60d4a&scoped=true"
import script from "./widgetPage.vue?vue&type=script&lang=js"
export * from "./widgetPage.vue?vue&type=script&lang=js"
import style0 from "./widgetPage.vue?vue&type=style&index=0&id=d6b60d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b60d4a",
  null
  
)

export default component.exports